import React, {Component} from 'react';
import {observer, inject} from "mobx-react";
import {StoreContext} from "../stores/contexts";

class SectionSearch extends Component {
  static contextType = StoreContext;
  
  constructor(props) {
    super(props);
    this.state={
      focus:false
    }
  }
  render() {
    return (
      <div className="pr">
        <input
          className="sectionsSearchField w100"
          placeholder="Поиск секции..."
          type="text"
          value={this.context.searchStore.search_query}
          onChange={(e)=>{
            this.context.searchStore.search(e.target.value);
          }}
          style={{paddingRight:20}}
          onFocus={()=>{ this.setState({ focus:true }) }}
          onBlur={()=>{ this.setState({ focus:false }) }}
        />
        {this.context.searchStore.search_query?(
          <div onClick={()=>{ this.context.searchStore.search(''); }} className={`pa pa-tr padd5 mdi mdi-close ${this.state.focus?'b1':'w1'} fs17 pointer`}></div>
        ):null}
      </div>
    )
  }
}

// export default inject("searchStore")(observer(SectionSearch));
export default observer(SectionSearch);